<template>
  <div class="container-fluid">
    <el-form v-if="!submited" @submit.prevent.native="resetPassword" class="login" :model="form" label-width="100px" :rules="formRules" ref="form">
      <h1>
        Obnovení hesla
      </h1>
      <el-form-item
        label="E-mail"
        prop="email"
        :rules="[
          { required: true, message: 'Zadejte e-mail', trigger: 'blur' },
          { type: 'email', message: 'Formát e-mailu není správný', trigger: ['blur', 'change'] }
        ]"
      >
        <el-input
            placeholder="Váš e-mail"
            v-model="form.email"
          ></el-input>
      </el-form-item>

      <div class="mb-4">
        <el-button native-type="submit">
          Odeslat požadavek
        </el-button>
      </div>

      <div class="mb-4" v-if="error.length">
        <p style="color: red">
          {{ error }}
        </p>
      </div>

      <div class="mb-4">
        <router-link :to="{
          name: 'login'
        }">
          Vrátit se na přihlášení
        </router-link>
      </div>
    </el-form>

    <h1 style="text-align: center" v-if="submited">
      Na váš e-mail byl odeslán odkaz pro nastavení hesla
      <br>
      <br>
      <router-link
        :to="{
          name: 'login'
        }"
      >
        Vrátit se na přihlášení
      </router-link>
    </h1>
  </div>
</template>

<script>
export default {
  name: 'ResetPassword',
  data() {
    var checkPass = (rule, value, callback) => {
      let regEx = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{12,}$/g
      if (!value) {
        return callback(new Error('Je to povinné pole'))
      } else if (!regEx.test(value)) {
        return callback(new Error('Minimálně 12 znaků. 1 malé a velké písmeno, jedna číslice'))
      }
      callback()
    };
    return {
      form: {
        email: '',
      },
      error: '',
      submited: false,
      formRules: {
        password: { validator: checkPass, trigger: 'blur' },
      }
    }
  },
  methods: {
    resetPassword() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$store.dispatch('resetPassword', this.form)
            .then(response => {
              this.submited = true
            })
            .catch(error => {
              this.error = 'Došlo k neočekáváně chybě, zkuste znovu'
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.login {
  margin-top: 100px;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}
</style>
